import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './Calendar.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { ref: "calendar", staticClass: "calendar", attrs: { tabindex: "-1" } },
    [
      _c("CalendarHeader", {
        attrs: {
          month: _vm.month,
          year: _vm.year,
          decade: _vm.decade,
          "current-interval": _vm.currentInterval,
          "data-cy": "header"
        },
        on: {
          "change-interval": _vm.onIntervalChange,
          next: _vm.onNext,
          prev: _vm.onPrev
        }
      }),
      _vm._v(" "),
      _vm.currentInterval === "days"
        ? _c("Weeks", {
            attrs: { weeks: _vm.weeks, "disabled-range": _vm.disabledRange },
            on: { "date-selected": _vm.onDateSelected }
          })
        : _vm.currentInterval === "months"
        ? _c("Months", {
            attrs: { "disabled-range": _vm.disabledRange },
            on: { "month-selected": _vm.onMonthSelected }
          })
        : _c("Years", {
            attrs: {
              "years-of-decade": _vm.yearsOfDecade,
              "disabled-range": _vm.disabledRange
            },
            on: { "year-selected": _vm.onYearSelected }
          })
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-3270b2e0";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Calendar/Calendar.vue.js